import React from 'react'
import { Button } from 'reactstrap'
import styled from 'styled-components'

export const generateButton = (button, click) => {
  switch (button) {
    case 'success': {
      return <Button color='success' onClick={ () => click() }>OK</Button>
    }
    case 'error': {
      return <Button color='warning' onClick={ () => click() }>Try Again</Button>
    }
    case 'confirm': {
      return (
        <div>
          <CustomButton onClick={ () => click('no') }>No</CustomButton>
          <CustomButton color='danger' onClick={ () => click('yes') }>Yes</CustomButton>
        </div>
      )
    }
    case 'discard': {
      return (
        <div>
          <CustomButton onClick={ () => click('no') }>No</CustomButton>
          <CustomButton color='danger' onClick={ () => click('yes') }>Yes</CustomButton>
        </div>
      )
    }
    case 'cancel': {
      return (
        <div>
          <CustomButton onClick={ () => click('no') }>No</CustomButton>
          <CustomButton color='danger' onClick={ () => click('yes') }>Yes</CustomButton>
        </div>
      )
    }
    default:
      return null
  }
}

const CustomButton = styled(Button)`
  margin-right: 10px ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
`



// WEBPACK FOOTER //
// ./src/components/my-leave/helpers/button.js